const getManifestTemplate = () => {
    const BASE_URL = window.location.origin;
    const START_URL = window.location.origin + window.location.search;

    return {
        short_name: 'IQOS App',
        name: 'IQOS App',
        icons: [
            {
                src: BASE_URL + '/icons/pwa-iqos-icon.svg',
                sizes: 'any',
                type: 'image/svg+xml',
            },
            {
                src: BASE_URL + '/icons/pwa-iqos-icon_48.png',
                sizes: '48x48',
                type: 'image/png',
            },
            {
                src: BASE_URL + '/icons/pwa-iqos-icon_72.png',
                sizes: '72x72',
                type: 'image/png',
            },
            {
                src: BASE_URL + '/icons/pwa-iqos-icon_96.png',
                sizes: '96x96',
                type: 'image/png',
            },
            {
                src: BASE_URL + '/icons/pwa-iqos-icon_128.png',
                sizes: '128x128',
                type: 'image/png',
            },
            {
                src: BASE_URL + '/icons/pwa-iqos-icon_144.png',
                sizes: '144x144',
                type: 'image/png',
            },
            {
                src: BASE_URL + '/icons/pwa-iqos-icon_152.png',
                sizes: '152x152',
                type: 'image/png',
            },
            {
                src: BASE_URL + '/icons/pwa-iqos-icon_192.png',
                sizes: '192x192',
                type: 'image/png',
            },
            {
                src: BASE_URL + '/icons/pwa-iqos-icon_256.png',
                sizes: '256x256',
                type: 'image/png',
            },
            {
                src: BASE_URL + '/icons/pwa-iqos-icon_384.png',
                sizes: '384x384',
                type: 'image/png',
            },
            {
                src: BASE_URL + '/icons/pwa-iqos-icon_512.png',
                sizes: '512x512',
                type: 'image/png',
                purpose: 'maskable',
            },
        ],
        display: 'standalone',
        orientation: 'portrait',
        start_url: START_URL + '/',
        background_color: '#fffdfb',
    };
};

export default getManifestTemplate;
